import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const fetchDependencies = async ({ queryKey }) => {
  const [, tcid] = queryKey;
  const user = getUserDetails();
  if (!tcid) return [];

  const response = await axios.get(`${API_BASE_PATH}${API_BASE_RELATIVE_PATH}`, {
    params: {
      action: "getDependencies",
      testcaseid: tcid,
      companyid: user.companyid,
    },
  });

  return response.data;
};

const useDependenciesQuery = (tcid) => {
  return useQuery({
    queryKey: ["dependencies", tcid],
    queryFn: fetchDependencies,
    enabled: !!tcid,
  });
};

export default useDependenciesQuery;
